import styled, { css } from 'styled-components';
import { Atom } from 'AppReact';

export const template = styled.div`
  ${({ displayState }) => css`
    display: ${displayState.hidden ? 'none' : 'flex'};
    align-items: center;
    justify-content: center;
    padding-left: 10px;
    padding-right: 10px;
    margin-right: 6px;
    height: ${displayState?.height ?? '22px'};

    background-color: ${displayState?.priority?.background};
    color: ${displayState?.priority?.textColor};;

    border-radius: 60px;

    font-size: 10px;
    line-height: 22px;

    user-select: none;
  `}
`;

export default Atom({ type: 'label', dataType: 'string', template });
